<template>
    <div class="back" ref="app">
        <div class="login transform-box" v-if="!registershow">
            <div class="left-things" ref="move">
                <div>
                    <img v-if="NewYear" src="../../assets/image/newyear/login-welcome1.png" alt="" class="welcome1">
                    <img v-else src="../../assets/image/login-welcome1.png" alt="" class="welcome1">
                    <img v-if="NewYear" src="../../assets/image/newyear/login-welcome2.png" alt="" class="welcome2">
                    <img v-else src="../../assets/image/login-welcome2.png" alt="" class="welcome2">
                </div>
            </div>
            <div class="logo-part">
                <div class="main-logo">
                    <div class="right-part" v-if="NewYear" style="bottom: -88px;transform: translateX(365px);">
                        <img src="../../assets/image/newyear/login-move-right2.png" alt="" class="right1"
                            style="width: 172px;height: 172px;">
                        <img src="../../assets/image/ball-shadow2.png" alt="" class="right2"
                            style="width:57px;margin-top: 24px;">
                    </div>
                    <div class="left-part" style="bottom: -101px;transform: translateX(-346px);">
                        <img v-if="NewYear" src="../../assets/image/newyear/login-move-left1.png" alt="" class="left1"
                            style="width: 150px;;height: 151px;">
                        <img v-else src="../../assets/image/login-move-left1.png" alt="" class="left1">
                        <img :class="{ 'blue': !NewYear }" src="../../assets/image/ball-shadow3.png" alt="" class="left2"
                            style="width: 76px;margin-top: 32px;">
                    </div>
                    <div class="left-part" v-if="NewYear" style="bottom: 166px;transform: translateX(-200px);">
                        <img src="../../assets/image/newyear/login-move-left2.png" alt="" class="left1"
                            style="width: 99px;height: 100px;">
                        <img src="../../assets/image/ball-shadow1.png" alt="" class="left2"
                            style="margin-top: 19px;width: 59px;">
                    </div>
                    <div class="middle-part" ref="loginpart2">
                        <img v-if="NewYear" src="../../assets/image/newyear/login-move-middle1.png" alt=""
                            class="middle1">
                        <img v-else src="../../assets/image/login-move-middle1.png" alt="" class="middle1">
                        <img src="../../assets/image/login-move-middle2.png" alt="" class="middle2">
                    </div>
                    <div class="right-part" style="bottom:158px;transform: translateX(253px);">
                        <img v-if="NewYear" src="../../assets/image/newyear/login-move-right1.png" alt="" class="right1"
                            style="width: 136px;height: 136px;">
                        <img v-else src="../../assets/image/login-move-right1.png" alt="" class="right1">
                        <img :class="{ 'blue': !NewYear }" src="../../assets/image/ball-shadow4.png" alt="" class="right2"
                            style="margin-top: 17px;width: 67px;">
                    </div>
                </div>
            </div>
            <div class="login-part  " ref="loginfather">
                <div v-if="login_type == 1" style="width: 100%;" ref="loginpart">
                    <div class="login-line" ref="loginpart3">
                        <img v-if="NewYear" src="../../assets/image/newyear/login-new-logo.png" alt="" class="logo">
                        <img v-else src="../../assets/image/login-new-logo.png" alt="" class="logo">
                        <!-- <img :src="!is_wechat ? require('../../assets/image/login-welogo.png') : require('../../assets/image/login-plant.png')" alt="" class="we-logo hover" @click="wechatLogin"> -->
                    </div>
                    <div v-if="!is_wechat" ref="loginpart4">
                        <div class="input-part" ref="inputpart">
                            <div style="display: none !important;"></div>
                            <div class="form-item" id="phone">
                                <input type="text" v-model="form.mobile" placeholder="手机号邮箱">
                                <img src="../../assets/image/login-labelicon1.png" alt="" class="tip-icon">
                                <span class="tip" v-show="is_phone_error">请输入正确的账号</span>
                            </div>
                            <div class="form-item">
                                <input :type="texttype" v-model="form.password" placeholder="请输入登录密码"
                                    @keyup.enter="loginIn">
                                <img src="../../assets/image/login-labelicon2.png" alt="" class="tip-icon">
                                <span class="eyes handel-icon hover" @click="seePwd">
                                    <local-svg v-if="is_show" iconClass="eye_open" class="icon"></local-svg>
                                    <local-svg v-else iconClass="eye_close" class="icon"></local-svg>
                                </span>
                                <span class="tip" v-show="is_password_error">密码输入错误, 请检查后再次尝试</span>
                            </div>
                        </div>
                        <div class="handle-part">
                            <div class="handle-left hover">
                                <div class="checkbox" @click="reminder = !reminder" :class="{ 'noborder': reminder }">
                                    <img src="../../assets/image/check-dark.png" alt="" v-if="reminder">
                                </div>
                                <span>记住账号</span>
                            </div>
                            <div class="handle-right">
                                <span class="hover" @click="toRegister">立即注册</span>
                                <span class="shu">|</span>
                                <span class="hover" @click="toForget">忘记密码？</span>
                            </div>
                        </div>
                        <div class="button-part">
                            <button class="login-btn hover" :class="NewYear ? 'yearLogin' : ''" type="button"
                                @click="loginIn">登录</button>
                        </div>
                        <div class="login-change">
                            <div class="border-line">
                                <div class="line"></div>
                                <span>或</span>
                            </div>
                            <div class="login-btn">
                                <img src="../../assets/image/login-wx.png" alt="" class="hover" @click="wechatLoginWX">
                                <img src="../../assets/image/login-qw.png" alt="" class="hover"
                                    style="margin-left: 40px;" @click="wechatLogin">
                            </div>
                        </div>
                    </div>
                    <div v-else :style="{ 'display': is_wechat ? 'black' : 'none' }" ref="loginpart5">
                        <div class="code-part" v-if="login_status == 3">
                            <div class="tip-left" id="wx_login3"></div>
                            <div class="tip-right">
                                <img src="../../assets/image/login-tip-image2.png" alt="">
                            </div>
                        </div>
                        <div class="code-part" v-if="login_status == 1">
                            <div class="tip-left" id="wx_login2"></div>
                            <div class="tip-right">
                                <img src="../../assets/image/login-tip-image2.png" alt="">
                            </div>
                        </div>
                        <div class="code-part" v-if="login_status == 2">
                            <div class="tip-left" id="wx_login1"></div>
                            <div class="tip-right2">
                                <img src="../../assets/image/login-tip-image2.png" alt="">
                            </div>
                        </div>
                        <div class="login-change" style="margin-top: -100px;">
                            <div class="border-line">
                                <div class="line"></div>
                                <span>或</span>
                            </div>
                            <div class="login-btn">
                                <img style="width: 45px;height: 45px;margin-right: 40px"
                                    src="../../assets/image/phone.png" alt="" class="hover" @click="is_wechat = 0">
                                <img src="../../assets/image/login-wx.png" alt="" class="hover"
                                    @click="is_wechat = 0, login_status = 3, removeElementById('wx_login3')"
                                    v-if="login_status == 2">
                                <img src="../../assets/image/login-wx-none.png" alt="" class="hover none"
                                    @click="login_status = 2, wxImg()" v-else>
                                <img src="../../assets/image/login-qw.png" alt="" class="hover"
                                    style="margin-left: 40px;" v-if="login_status == 1"
                                    @click="is_wechat = 0, removeElementById('wx_login3'), login_status = 3">
                                <img src="../../assets/image/login-qw-none.png" alt="" class="hover none"
                                    style="margin-left: 40px;" @click="login_status = 1, qwImg()" v-else>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="forget-part" v-else>
                    <div class="forget-header">
                        <div class="header-left">
                            忘记密码<span>欢迎使用滨航门户</span>
                        </div>
                        <div class="header-right">
                            已有账号,<span class="handel-text hover" @click="toLogin">去登录</span>
                        </div>
                    </div>
                    <div class="forget-form">
                        <div class="form-item">
                            <input type="text" v-model="form.mobile" placeholder="手机号" @blur="blurResetInput('mobile')">
                            <img src="../../assets/image/login-labelicon1.png" alt="" class="tip-icon">
                            <span class="tip" v-show="is_phone_error">{{ tempdata.mobile ? '请输入正确的手机号' : '请输入手机号' }}</span>
                        </div>
                        <div class="form-item">
                            <input type="text" v-model="form.email" placeholder="邮箱" @blur="blurResetInput('email')">
                            <img src="../../assets/image/youxiang.png" alt="" class="tip-icon">
                            <span class="tip" v-show="is_email_error">{{ tempdata.email ? '请输入正确的邮箱' : '请输入邮箱' }}</span>
                        </div>
                        <div class="form-item">
                            <input type="text" v-model="form.code" placeholder="请输入验证码" @blur="blurResetInput('code')">
                            <img src="../../assets/image/login-labelicon2.png" alt="" class="tip-icon">
                            <span class="tip" v-show="is_code_error">验证码输入错误, 请检查后再次尝试</span>
                            <div class="code hover" @click="getCode" :class="{ 'disable': !ganCodeVis }">
                                <span v-if="ganCodeVis">发送验证码</span>
                                <span v-else>{{ CodeTime }}s后重新发送</span>
                            </div>
                        </div>
                        <div class="form-item">
                            <input type="text" v-model="form.password" placeholder="密码不少于6位且不超过12位"
                                @keyup.enter="resetPwd" @blur="blurResetInput('password')">
                            <img src="../../assets/image/login-labelicon2.png" alt="" class="tip-icon">
                            <span class="tip" v-show="is_password_error">密码错误, 请检查后再次尝试</span>
                        </div>
                        <div class="button-part" style="margin-top: 60px;">
                            <button class="login-btn hover" type="button" @click="resetPwd">确定</button>
                        </div>
                    </div>
                </div>
                <div class="tip-part" ref="loginpart1">
                    <p>版权所有：滨航企业管理（天津）集团有限公司 | 备案号: 津ICP备19009508号</p>
                    <p>技术支持：两航（天津）数字科技有限公司</p>
                    <p>建议您使用Chrome、Firefox、Edge、IE10及以上版本和360等主流浏览器浏览本网站</p>
                </div>
                <div class="helper hover" :class="{ 'show-code': show_code }" @click="show_code = !show_code">
                    <div class="tip-line">
                        <img src="../../assets/image/login-helper.png" alt="" class="logo">
                        <span>技术支持</span>
                    </div>
                    <img src="../../assets/image/helper-code.png" alt="" class="code" v-if="show_code">
                    <div class="back" v-if="show_code"></div>
                </div>
            </div>
        </div>
        <registerview v-else @fh="registershow = false"></registerview>
    </div>
</template>

<script>
import { jumplogin_fw, jumplogin_oa } from '@/api/login';
import { Login, code, reset, sendCodeEmail } from './api';
// import { scrm_login } from '@/api/scrm';
import { routesData } from '@/utils/permission'
import registerview from '@/components/login/register.vue'
const Base64 = require('js-base64').Base64
import {nav_arr} from '@/utils/nav_list'
export default {
    name: 'home',
    components: {
        registerview
    },
    data() {
        return {
            is_show: true,
            reminder: false,
            is_phone_error: false,
            is_password_error: false,
            is_code_error: false,
            is_email_error: false,
            ganCodeVis: true,
            show_code: false,
            phone: '',
            login_id: '',
            is_wechat: 0,
            login_type: 1,
            login_status: 3,
            CodeTime: 60,
            texttype: 'password',
            pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
            form: {
                mobile: '',
                password: '',
                code: '',
                email:"",
            },
            registershow: false,
            NewYear: this.$New_Year,
            emailRegex:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            tempdata:{},
        }
    },
    mounted() {
        // console.log('新年',this.$New_Year)
        let mobile = window.localStorage.getItem('phone')
        let password = Base64.decode(window.localStorage.getItem('password'))
        if (mobile && mobile != 'null') {
            this.form.mobile = mobile
            this.form.password = password
            this.reminder = true
        }
        window.addEventListener('resize', this.handleResize)
        this.handleResize()
        // 在这里执行你的宽度变化逻辑
        // 例如调整元素大小、重新计算布局等

    },
    methods: {
        wechatLogin() {
            // this.clearForm()
            this.is_wechat = 1
            this.login_status = 1
            if (this.is_wechat) {
                this.qwImg()
            }

        },
        wechatLoginWX() {
            this.is_wechat = 1
            this.login_status = 2
            if (this.is_wechat) {
                this.wxImg()
            }
        },
        removeElementById(id) {
            var element = document.getElementById(id);
            if (element) {
                element.parentNode.removeChild(element);
            }
        },
        toForget() {
            this.login_type = 2
            this.clearForm()
        },
        toRegister() {
            this.registershow = true
        },
        toLogin() {
            this.login_type = 1
            this.clearForm()
        },
        blurResetInput(value){
            this.tempdata = { ...this.form }
            if (value == 'mobile' && this.is_phone_error) {
                if (!this.form.mobile || this.form.mobile && !this.pattern.test(this.form.mobile)) {
                    this.is_phone_error = true
                } else {
                    this.is_phone_error = false
                }
            }
            if (value == 'email' && this.is_email_error) {
                if (!this.form.email || this.form.email && !this.emailRegex.test(this.form.email)) {
                    this.is_email_error = true
                } else {
                    this.is_email_error = false
                }
            }
            if (value == 'code' && this.is_code_error) {
                if (!this.form.code) {
                    this.is_code_error = true
                } else {
                    this.is_code_error = false
                }
            }
            if (value == 'password' && this.is_password_error) {
                if (!this.form.password) {
                    this.is_password_error = true
                } else {
                    this.is_password_error = false
                }
            }
        },
        resetPwd() {
            this.tempdata = { ...this.form }
            if (!this.form.mobile || this.form.mobile && !this.pattern.test(this.form.mobile)) {
                this.is_phone_error = true
                return
            } else {
                this.is_phone_error = false
            }
            if (!this.form.email || this.form.email && !this.emailRegex.test(this.form.email)) {
                this.is_email_error = true
                return
            } else {
                this.is_email_error = false
            }
            if (!this.form.code) {
                this.is_code_error = true
                return
            } else {
                this.is_code_error = false
            }
            if (!this.form.password) {
                this.is_password_error = true
                return
            } else {
                this.is_password_error = false
            }
            let data = {
                mobile: this.form.mobile,
                code: this.form.code,
                password: this.form.password,
                email: this.form.email,
            }
            reset(data).then(res => {
                if (res.code === 200) {
                    this.$message({
                        message: '修改成功，请重新登陆！',
                        type: 'success'
                    })
                    this.toLogin()
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
        },
        getCode() {
            this.tempdata = { ...this.form }
            if (!this.form.mobile || this.form.mobile && !this.pattern.test(this.form.mobile)) {
                this.is_phone_error = true
            } else {
                this.is_phone_error = false
            }

            if (!this.form.email || this.form.email && !this.emailRegex.test(this.form.email)) {
                this.is_email_error = true
            } else {
                this.is_email_error = false
            }

            if (this.is_phone_error || this.is_email_error) {
                return
            }

            if (!this.ganCodeVis) {
                this.$message.error('请勿重复获取！')
                return
            }
            let data = {
                mobile: this.form.mobile,
                email:this.form.email,
            }
            sendCodeEmail(data).then(res => {
                if (res.code === 200) {
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    })
                    this.ganCodeVis = false
                    setInterval(() => {
                        if (this.CodeTime === 0) {
                            this.ganCodeVis = true

                        } else {
                            this.CodeTime = this.CodeTime - 1
                        }
                    }, 1000)
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })
        },
        qwImg() {
            setTimeout(() => {
                (window).WwLogin({
                    "id": "wx_login2",
                    "appid": "ww6762914172a75da1",
                    "agentid": "1000040",
                    "redirect_uri": `https://one.tjlhyg.com/wxlogin?id=${this.login_id}`,     //回调页面
                    "state": "",
                    "href": `
                        data:text/css;base64,${Base64.encode(
                        `.frame_wrap{width: 197px !important;height:197px !important;}
                        .impowerBox .qrcode {width: 197px !important;}
                        .impowerBox {width: 197px !important;height:197px !important;}
                        .impowerBox .title {display:none !important;}
                        .impowerBox .status {display:none !important;}
                        .impowerBox .wrp_code {width:197px !important;margin-top:0 !important;margin-left:40px !important;}
                        .impowerBox .normalPanel {width:197px !important}
                        .impowerBox .waiting{width:197px !important;margin-top:0}` )}`,
                });
            }, 100)
        },
        wxImg() {
            let _this = this;
            setTimeout(() => {
                (window).WxLogin({
                    id: "wx_login1",
                    appid: "wxe36f445a7fc1bd83",  // 这个appid要填死
                    scope: "snsapi_login",
                    // 扫码成功后重定向的接口
                    redirect_uri: encodeURIComponent("https://one.tjlhyg.com/WeChatAuthLogin"),
                    // redirect_uri: encodeURIComponent("https://one.tjbinhang.cn/#/wxlogin"),
                    href: `data:text/css;base64,${Base64.encode(
                        `	 frame{width: 197px !important;height:197px !important;}
                            .web_qrcode_type_iframe{width:197px;height:197px;}
                            .frame_wrap{width: 197px !important;height:197px !important;}
                            .impowerBox .qrcode {width: 197px !important;margin-top:3px !important;margin-left:40px;}
                            .impowerBox {width: 197px !important;height:197px !important;}
                            .impowerBox .title {display:none !important;}
                            .impowerBox .status {display:none !important;}
                            .impowerBox .wrp_code {width:197px !important;margin-top:0 !important;}
                            .impowerBox .normalPanel {width:197px !important}
                            .impowerBox .waiting{width:197px !important;margin-top:0}`
                    )}`,
                    response_type: 'authorization_code',
                    fast_login: 0,
                    // state填写编码后的url
                    state: 'wxlogin',
                    // 调用样式文件
                });
            }, 100)
        },
        loginIn() {
            this.tempdata = { ...this.form }
            if (!this.form.mobile || this.form.mobile && !this.pattern.test(this.form.mobile)) {
                this.is_phone_error = true
                return
            } else {
                this.is_phone_error = false
            }
            if (!this.form.password) {
                this.is_password_error = true
                return
            } else {
                this.is_password_error = false
            }
            let data = {
                mobile: this.form.mobile,
                password: this.form.password
            }
            // Login(data).then(res=>{
            //     // console.log(res);
            //     if (res.code === 200) {
            //         if(!res.data.userid){
            //             this.$message.error('未绑定企业微信，请先使用企业微信扫码后登录')
            //             setTimeout(()=>{
            //                 this.login_id = res.data.id
            //                 this.wechatLogin()
            //             },1500)
            //             return
            //         }
            //         this.$message({
            //             message: res.msg,
            //             type: 'success'
            //         })
            //         if (this.reminder === true) {
            //             window.localStorage.setItem('phone', this.form.mobile)
            //             let password = Base64.encode(this.form.password)
            //             window.localStorage.setItem('password', password)
            //         }
            //         else {
            //             window.localStorage.setItem('phone', '')
            //             window.localStorage.setItem('password', '')
            //         }
            //         window.localStorage.setItem('token', res.data.token)
            //         this.$store.commit('setUserName', res.data.name)
            //         this.$store.commit('setUserId', res.data.id)
            //         this.$store.commit('setUserImage', res.data.image)
            //         this.$store.commit('setUserRole', res.data.role)
            //         this.$store.commit('setNavTab', [])
            //         // this.getLoginInfo()
            //         // this.getLoginInfo2()
            //         // this.getLoginInfo3(res.data.id)
            //         // setTimeout(()=>{
            //         //     localStorage.setItem('system_index',1)
            //         //     this.$router.push('/custom')
            //         // },1500)
            //         let permission_list = []
            //         res.data.client_permission.forEach(item =>{
            //             // if(item.name == '线索公海'){
            //             // }
            //             // else{
            //                 item.plant_type = 3
            //                 permission_list.push(item)
            //                 item.login_header = 1
            //             // }
            //         })
            //         res.data.oa_permission.forEach(item => {
            //             item.plant_type = 1
            //             permission_list.push(item)
            //             item.login_header = 2
            //         });
            //         res.data.wuye_permission.forEach(item => {
            //             item.plant_type = 11
            //             permission_list.push(item)
            //             item.login_header = 11
            //         });
            //         res.data.waiqin_permission.forEach(item =>{
            //             if(item.name == '资产管理' || item.name == '物业管理' ){
            //             }
            //             else{
            //                 item.plant_type = 2
            //                 if(item.name == '资产管理'){
            //                     item.url = 'https://zcgl.lianghang.cc/'
            //                 }
            //                 if(item.name == '物业管理'){
            //                     item.url = 'https://bhwy.tjbinhang.cn/web/#/login'
            //                 }
            //                 permission_list.push(item)
            //                 item.login_header = 3
            //             }
            //         })
            //         res.data.menhu_permission.forEach(item =>{
            //             item.plant_type = item.name == '文件管理' ? 4 : item.name == '消息中心' ? 5 : item.name == '组织架构' ? 6 : item.name == '系统设置' ? 7 :item.name == '工作台' ? 10 : ''
            //             item.login_header = item.name == '文件管理' ? 4 : item.name == '消息中心' ? 5 : item.name == '组织架构' ? 6 : item.name == '系统设置' ? 7 :item.name == '工作台' ? 10 : ''
            //             if(item.plant_type == 5 || item.plant_type == 6 || item.plant_type == 7 || item.plant_type == 10){
            //                 item.page.forEach(val =>{
            //                     let obj = {
            //                         has_child:2,
            //                         comp:val.comp,
            //                         comp_addr:val.comp_addr,
            //                         icon:val.icon,
            //                         route:val.route,
            //                         name:val.name,
            //                         id:val.id,
            //                         plant_type:item.plant_type,
            //                         page:[]
            //                     }
            //                     obj.page.push({button:val.button})
            //                     permission_list.push(obj)
            //                 })
            //             }else{
            //                 permission_list.push(item)
            //             }
            //         })
            //         this.getLoginInfo3(res.data.id)
            //         this.$store.commit('setUserPower', permission_list)
            //         routesData(this.$store.state.userpower)
            //         this.setBtnPower(permission_list)
            //         setTimeout(()=>{
            //             let path = ''
            //             let system_index = 10
            //             console.log(permission_list)
            //             // permission_list.forEach((item,index) =>{
            //             //     if(index == 0){
            //             //         system_index = item.login_header
            //             //         if(item.has_child == 2){
            //             //             path = item.route
            //             //         }else{
            //             //             path = item.page[0].route
            //             //         }
            //             //     }
            //             // })
            //             localStorage.setItem('system_index',system_index)
            //             this.$router.push('/terrace/personal')
            //             // this.$router.push('/contract')
            //         },1500)
            //         // this.setBtnPower(res.data.permission)
            //         // await this.$router.push('/custom')
            //     } else {
            //         this.$message({
            //             message: res.msg,
            //             type: 'error'
            //         })
            //     }
            // })
            Login(data).then(res => {
                if (res.code === 200) {
                    if (!res.data.userid) {
                        this.$message.error('未绑定企业微信，请先使用企业微信扫码后登录')
                        setTimeout(() => {
                            this.login_id = res.data.id
                            this.wechatLogin()
                        }, 1500)
                        return
                    }

                    this.$message({
                        message: res.msg,
                        type: 'success'
                    })

                    if (this.reminder === true) {
                        window.localStorage.setItem('phone', this.form.mobile)
                        let password = Base64.encode(this.form.password)
                        window.localStorage.setItem('password', password)
                    } else {
                        window.localStorage.setItem('phone', '')
                        window.localStorage.setItem('password', '')
                    }

                    window.localStorage.setItem('token', res.data.token)
                    this.$store.commit('setUserName', res.data.name)
                    this.$store.commit('setUserId', res.data.id)
                    this.$store.commit('setUserImage', res.data.image)
                    this.$store.commit('setUserRole', res.data.role)
                    this.$store.commit('setNavTab', [])

                    let permission_list = []

                    // 容错函数
                    const getSafeArray = (data) => Array.isArray(data) ? data : []

                      getSafeArray(res.data.client_permission).forEach(item => {
                        item.plant_type = 3
                        permission_list.push(item)
                        item.login_header = 1
                      })

                      getSafeArray(res.data.oa_permission).forEach(item => {
                        item.plant_type = 1
                        permission_list.push(item)
                        item.login_header = 2
                      })

                      getSafeArray(res.data.wuye_permission).forEach(item => {
                        item.plant_type = 11
                        permission_list.push(item)
                        item.login_header = 11
                      })

                      getSafeArray(res.data.waiqin_permission).forEach(item => {
                        if (item.name === '资产管理' || item.name === '物业管理') {
                          // 空操作，按你原代码保留
                        } else {
                          item.plant_type = 2
                          if (item.name === '资产管理') {
                            item.url = 'https://zcgl.lianghang.cc/'
                          }
                          if (item.name === '物业管理') {
                            item.url = 'https://bhwy.tjbinhang.cn/web/#/login'
                          }
                          permission_list.push(item)
                          item.login_header = 3
                        }
                      })

                    const routeArr = ['/managereport', '/park-report']
                    let dataReport = []
                    getSafeArray(res.data.menhu_permission).forEach(item => {
                        item.plant_type =
                            item.name === '消息中心' ? 5 :
                                item.name === '组织架构' ? 6 :
                                    item.name === '系统设置' ? 7 :
                                        item.name === '工作台' ? 10 : ''

                        item.login_header = item.plant_type

                        if ([5, 6, 7, 10].includes(item.plant_type)) {
                            getSafeArray(item.page).forEach(val => {
                                let obj = {
                                    has_child: 2,
                                    comp: val.comp,
                                    comp_addr: val.comp_addr,
                                    icon: val.icon,
                                    route: val.route,
                                    name: val.name,
                                    id: val.id,
                                    plant_type: item.plant_type,
                                    page: []
                                }
                                if (routeArr.includes(val.route)) {
                                    obj.button = val.button
                                    dataReport.push(obj)
                                } else {
                                    obj.page.push({ button: val.button })
                                    permission_list.push(obj)
                                }
                            })
                        }
                        else if (item.name === '文件管理') {
                            console.log(item)
                            item.login_header = 10
                            let obj = {
                                has_child: 2,
                                comp: item.comp,
                                comp_addr: item.comp_addr,
                                icon: 'filemanage',
                                route: item.route,
                                name: item.name,
                                id: item.id,
                                plant_type: item.login_header,
                                page: []
                            }
                            obj.page.push({ button: item.page[0].button })
                            permission_list.push(obj)
                        }
                        else {
                            permission_list.push(item)
                        }
                    })

                    permission_list.push({
                        comp: "",
                        comp_addr: "",
                        has_child: 1,
                        icon: "data",
                        id: 987,
                        login_header: 10,
                        name: "数据列表",
                        plant_type: 10,
                        route: "/datareport",
                        page: dataReport
                    })

                    console.log(permission_list)
                    if (res.data.project_permission) {
                        res.data.project_permission.forEach(item => {
                            if (item.name === '技术服务') {
                                item.page.forEach(val => {
                                    let obj = {
                                        has_child: 2,
                                        comp: val.comp,
                                        comp_addr: val.comp_addr,
                                        icon: val.icon,
                                        route: val.route,
                                        name: val.name,
                                        id: val.id,
                                        plant_type: 12,
                                        page: []
                                    }
                                    obj.page.push({ button: val.button })
                                    permission_list.push(obj)
                                })
                            }
                        })
                        nav_arr().list2.forEach(item => {
                            let obj = {
                                has_child: item.has_child,
                                comp: item.comp,
                                comp_addr: item.comp_addr,
                                icon: item.icon,
                                route: item.route,
                                name: item.name,
                                id: item.id,
                                plant_type: 12,
                                page: item.page
                            }
                            permission_list.push(obj)
                        })

                    }

                    // permission_list.push(...[
                    //     // {
                    //     //     comp: "mapping-manage",
                    //     //     comp_addr: "/system/mapping-manage",
                    //     //     has_child: 2,
                    //     //     icon: "icon-bill",
                    //     //     id: 155,
                    //     //     login_header: 7,
                    //     //     name: "映射管理",
                    //     //     plant_type: 7,
                    //     //     route: "/mapping-manage",
                    //     //     page: [],
                    //     // },
                    //     {
                    //         name: "数据列表",
                    //         route: "/data-report",
                    //         comp: "",
                    //         comp_addr: "",
                    //         has_child: 1,
                    //         icon: "data",
                    //         id: 520,
                    //         login_header: 10,
                    //         plant_type: 10,
                    //         page: [
                    //             {
                    //             name: "业务报表",
                    //             route: "/product-report",
                    //             comp: "/data-report/product-report",
                    //             comp_addr: "/data-report/product-report",
                    //             id: 521,
                    //             button: [],
                    //             },
                    //         ],
                    //     }
                    // ])

                    // permission_list.push(...[
                    //     {
                    //         comp: "asset",
                    //         comp_addr: "",
                    //         has_child: 1,
                    //         icon: "asset-icon",
                    //         id: 89,
                    //         login_header: 11,
                    //         name: "资产管理",
                    //         page: [{
                    //             comp: "asset-manage/asset-view",
                    //             comp_addr: "asset-manage/asset-view",
                    //             icon: "",
                    //             id: 99,
                    //             name: "资产视图",
                    //             route: "/asset-manage/asset-view",
                    //         },
                    //         {
                    //             comp: "asset-manage/all-asset",
                    //             comp_addr: "asset-manage/all-asset",
                    //             icon: "",
                    //             id: 120,
                    //             name: "全部资产",
                    //             route: "/asset-manage/all-asset",
                    //         }],
                    //         plant_type: 11,
                    //         route: "/asset",
                    //     }
                    // ])

                    this.getLoginInfo3(res.data.id)
                    this.$store.commit('setUserPower', permission_list)
                    routesData(this.$store.state.userpower)
                    this.setBtnPower(permission_list)

                    setTimeout(() => {
                        let path = ''
                        let system_index = 10
                        console.log(permission_list)

                        localStorage.setItem('system_index', system_index)
                        this.$router.push('/terrace/personal')
                    }, 1500)

                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    })
                }
            })

        },
        getLoginInfo3(id) {
            let data = {
                tenant_id: 1,
                id: 31,
            }
            // scrm_login(data).then(res=>{
            //     window.localStorage.setItem('SCRM_TOKEN', res.data.token)
            //     window.localStorage.setItem('SCRM_SIGN', res.data.sign_key)
            // })
        },
        setBtnPower(array) {
            let arr = []
            for (var a = 0; a < array.length; a++) {
                let item = array[a]
                for (var b = 0; b < item.page.length; b++) {
                    let initem = item.page[b]
                    if (initem.button) {
                        for (var c = 0; c < initem.button.length; c++) {
                            let btnname = item.has_child == 1 ? initem.name + '-' + initem.button[c] : item.name + '-' + initem.button[c]
                            arr.push(btnname)
                        }
                    }

                }
            }
            this.$store.commit('setUserBtn', arr)
        },
        seePwd() {
            this.is_show = !this.is_show
            this.is_show === true ? this.texttype = 'password' : this.texttype = 'text'
        },
        getLoginInfo() {
            let data = {
                platform: 'portal'
            }
            jumplogin_oa(data).then(res => {
                window.localStorage.setItem('OA_TOKEN', res.data.token)
                // this.setBtnPower(res.data.permission)
            })
        },
        getLoginInfo2() {
            let data = {
                platform: 'portal'
            }
            jumplogin_fw(data).then(res => {
                window.localStorage.setItem('FW_TOKEN', res.data.token)
            })
        },
        clearForm() {
            this.form = {
                mobile: '',
                code: '',
                password: '',
                email:"",
            }
            this.tempdata = {}
            this.is_phone_error = false
            this.is_password_error = false
            this.is_code_error = false
            this.is_email_error = false
            this.reminder = false
        },
        handleResize() {
            this.$nextTick(() => {
                const baseWidth = 1920; // 基准视口宽度
                const baseHeight = 1080; // 基准视口宽度
                const currentHeight = window.innerHeight;
                const currentWidth = window.innerWidth;
                const scale = currentWidth / baseWidth; // 计算缩放比例
                const scale_1 = scale * 1.5; // 计算缩放比例
                const scale_width = 500 * scale; // 计算缩放比例
                const scale_padding = scale * 95; // 计算缩放比例
                if (currentWidth < 1920) {
                    this.$refs.move.style.transform = `scale(${scale})`;
                    this.$refs.move.style['transform-origin'] = ` 0 0`;
                    this.$refs.loginpart.style.transform = `scale(${scale})`;
                    this.$refs.loginpart.style['min-width'] = `500px`;
                    // this.$refs.loginpart.style['transform-origin'] = `center left`;
                    this.$refs.loginpart1.style.transform = `scale(${scale})`;
                    // this.$refs.loginpart1.style['transform-origin'] = `bottom left`;
                    this.$refs.loginpart1.style['min-width'] = `500px`;
                    this.$refs.loginpart1.style.bottom = 54 * scale + 'px';
                    this.$refs.loginpart2.style.transform = `scale(${scale})`;
                    this.$refs.loginpart2.style['transform-origin'] = `bottom center`;
                    // scaleX(0.8) scaleY(1.2)
                    // transform-origin: 0 0;
                }
            })
            // if(width < 1200){

            // }else{
            // 	this.$refs.app.style.zoom = `1`;
            // }
        },
    },
    beforeDestroy() {
        // 取消监听窗口大小的改变事件
        window.removeEventListener('resize', this.handleResize);
    }
}
</script>

<style lang="scss" scoped>
.back {
    background: #DCE3ED;
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    // min-width: 1745px;
}

@media (min-width: 1921px) {
    .back {
        background: #DCE3ED;
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .login-part {
        width: 690px !important;
        height: 100vh;
        background: #fff;
        position: absolute;
        right: 0;
        top: 0;
        padding: 0 95px !important;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    // .login{
    //     width: 1920px !important;
    //     height: 100vh !important;
    //     background: url('../../assets/image/backimage.png') no-repeat;
    //     background-size: 100% 100% !important;
    //     position: relative;
    //     box-sizing: border-box;
    //     padding:7.8% 0 0  8.9%;
    // }
}

// @media (max-width: 1746px) {
//     .back {
//         background: #DCE3ED;
//         width: 100%;
//         height: 100vh;
//         display: flex;
//         align-items: center;
//         justify-content: flex-start;
//         min-width: 1746px;
//     }

//     .login{
//         width: 1746px !important;
//         height: 876px !important;
//         background: url('../../assets/image/backimage.png') no-repeat;
//         position: relative;
//         box-sizing: border-box;
//         padding:7.8% 0 0  8.9%;
//         .login-part{
//             height: 100% !important;
//         }
//     }
// }

.login {
    width: 100%;
    height: 100vh;
    background: url('../../assets/image/backimage.png') no-repeat;
    background-size: cover;
    position: relative;
    box-sizing: border-box;
    padding: 7.8% 0 0 8.9%;
    overflow: hidden;

    .helper {
        width: 39px;
        height: 117px;
        background: linear-gradient(152deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0.47)) 1 1;
        border-radius: 6px 0px 0px 6px;
        border: 1px solid #fff;
        // border-image: ;
        padding: 15px 10px 0;
        position: absolute;
        left: -39px;
        bottom: 120px;
        box-sizing: border-box;

        .tip-line {
            display: flex;
            flex-direction: column;
            width: 18px;
            height: 100%;
            position: relative;
            z-index: 9;

            .logo {
                width: 18px;
                height: 16px;
            }

            span {
                font-size: 14px;
                color: #76859A;
                line-height: 16px;
                margin-top: 7px;
                margin-left: 2px;
            }
        }

        .code {
            width: 90px;
            height: 90px;
            position: absolute;
            right: 14px;
            top: 14px;
            margin-left: 22px;
            z-index: 9;
        }

        .back {
            width: 154px;
            height: 117px;
            padding: 1px;
            box-sizing: border-box;
            background: rgba(255, 255, 255, 0.48);
            left: 0;
            top: 0;
            position: absolute;
        }
    }

    .show-code.helper {
        width: 154px;
        padding: 14px;
        box-sizing: border-box;
        left: -154px;
    }

    .login-part {
        width: 35.97vw;
        height: 100vh;
        background: #fff;
        position: absolute;
        right: 0;
        top: 0;
        padding: 0 4.94vw;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;

        .login-line {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 71px;

            .logo {
                width: 280px;
                height: 70px;
            }

            .we-logo {
                width: 68px;
                height: 68px;
            }
        }

        .forget-part {
            width: 100%;
            height: auto;

            .forget-header {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                height: 71px;

                .header-left {
                    display: flex;
                    align-items: flex-end;
                    font-size: 31px;
                    color: #142F55;
                    line-height: 44px;

                    span {
                        font-size: 16px;
                        color: #9A9EAD;
                        line-height: 22px;
                        margin-bottom: 3px;
                        margin-left: 12px;
                    }
                }

                .header-right {
                    font-size: 16px;
                    color: #252B41;
                    line-height: 22px;
                    margin-bottom: 3px;

                    span {
                        font-size: 16px;
                        color: #57669F;
                        line-height: 22px;
                    }
                }
            }

            .forget-form {
                margin-top: 69px;
                width: 100%;
                height: auto;

                .form-item {
                    width: 100%;
                    padding-bottom: 28px;
                    box-sizing: border-box;
                    position: relative;
                    height: 82px;

                    iframe {
                        display: none !important;
                    }

                    input {
                        outline: none;
                        width: 100%;
                        height: 54px;
                        background: rgba(181, 191, 204, 0.14);
                        border-radius: 6px;
                        border: none;
                        font-size: 16px;
                        color: #252B41;
                        line-height: 22px;
                        box-sizing: border-box;
                        padding-left: 50px;
                    }

                    input::placeholder {
                        color: #C2C6D4;
                    }

                    .tip-icon {
                        width: 14px;
                        height: 19px;
                        position: absolute;
                        left: 24px;
                        top: 18px;
                        object-fit: contain;
                    }

                    .tip {
                        font-size: 12px;
                        color: #E84637;
                        line-height: 17px;
                        position: absolute;
                        bottom: 7px;
                        left: 0;
                    }

                    .code {
                        width: 130px;
                        height: 44px;
                        background: #496183;
                        border-radius: 4px;
                        position: absolute;
                        right: 5px;
                        top: 5px;
                        text-align: center;
                        font-size: 16px;
                        color: #FFFFFF;
                        line-height: 44px;
                    }

                    .code:hover {
                        background: #364C6C;
                    }

                    .disable {
                        background: rgba(73, 97, 131, 0.2) !important;
                        color: #fff !important;
                    }

                    .eyes {
                        position: absolute;
                        top: 21px;
                        right: 24px;
                        width: 19px;
                        height: 12px;

                        .icon {
                            width: 19px;
                            height: 12px;
                            vertical-align: 0;
                            color: #969CAC;
                        }
                    }
                }
            }

        }
    }

    .input-part {
        margin-top: 81px;
        width: 100%;
        height: auto;

        .form-item {
            width: 100%;
            padding-bottom: 28px;
            box-sizing: border-box;
            position: relative;
            height: 82px;

            input {
                outline: none;
                width: 100%;
                height: 54px;
                background: rgba(181, 191, 204, 0.14);
                border-radius: 6px;
                border: none;
                font-size: 16px;
                color: #252B41;
                line-height: 22px;
                box-sizing: border-box;
                padding-left: 50px;
            }

            input::placeholder {
                color: #C2C6D4;
            }

            .tip-icon {
                width: 14px;
                height: 19px;
                position: absolute;
                left: 24px;
                top: 18px;
            }

            .tip {
                font-size: 12px;
                color: #E84637;
                line-height: 17px;
                position: absolute;
                bottom: 7px;
                left: 0;
            }

            .eyes {
                position: absolute;
                top: 21px;
                right: 24px;
                width: 19px;
                height: 12px;

                .icon {
                    width: 19px;
                    height: 12px;
                    vertical-align: 0;
                    color: #969CAC;
                }
            }
        }
    }

    .code-part {
        margin-top: 119px;
        width: 100%;
        height: auto;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 40px;

        .tip-left {
            width: 197px;
            height: auto;
            display: flex;
            justify-content: center;
        }

        .tip-right {
            width: 201px;
            height: 197px;
            background: url('../../assets/image/login-tip-image1.png') no-repeat;
            background-size: 100% 100%;

            img {
                width: 146px;
                height: 124px;
                margin-top: 43px;
                margin-left: -11px;
            }
        }

        .tip-right2 {
            width: 201px;
            height: 197px;
            background: url('../../assets/image/login-tip-image3.png') no-repeat;
            background-size: 100% 100%;

            img {
                width: 146px;
                height: 124px;
                margin-top: 43px;
                margin-left: -11px;
            }
        }
    }

    .handle-part {
        width: 100%;
        height: 22px;
        margin-top: -2px;
        justify-content: space-between;
        align-items: center;
        display: flex;

        .handle-left {
            display: flex;
            align-items: center;

            .checkbox {
                width: 16px;
                height: 16px;
                border: 1px #D5D8DE solid;
                box-sizing: border-box;
                border-radius: 4px;

                img {
                    width: 16px;
                    height: 16px;
                }
            }

            .noborder {
                border: none !important;
            }

            span {
                margin-left: 10px;
                font-size: 16px;
                color: #252B41;
                line-height: 16px;
            }
        }

        .handle-left:hover {
            .checkbox {
                border-color: #496183 !important;
            }
        }

        .handle-right {
            display: flex;
            align-items: center;

            span {
                font-size: 16px;
                color: #A3A7B5;
                line-height: 16px;
            }

            span:hover {
                color: #57669F;
            }

            .shu {
                margin: 0 16px;
                font-size: 12px;
                color: #A3A7B5;
            }
        }
    }

    .button-part {
        width: 100%;
        height: 54px;
        margin-top: 77px;

        button {
            outline: none;
            border: none;
            width: 100%;
            height: 54px;
            background: #496183;
            border-radius: 6px;
            text-align: center;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 54px;
            justify-content: center;
        }

        button:hover {
            background: #364C6C;
        }
    }

    .login-change {
        width: 100%;
        height: auto;
        margin-top: 24px;

        .border-line {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 20px;
            position: relative;

            span {
                padding: 0 15px;
                box-sizing: border-box;
                font-size: 14px;
                color: #A3A7B5;
                line-height: 20px;
                background: #fff;
                position: absolute;
                margin: 0 auto;
            }

            .line {
                width: 100%;
                height: 1px;
                background: #ECEDF2;
            }
        }

        .login-btn {
            width: 100%;
            align-items: center;
            display: flex;
            justify-content: center;
            margin-top: 13px;

            img {
                width: 52px;
                height: 52px;

            }

            .none {
                width: 45px;
                height: 45px;
            }
        }
    }

    .tip-part {
        position: absolute;
        bottom: 54px;
        // left: 95px;
        width: auto;
        height: auto;

        p {
            margin-top: 8px;
            font-size: 13px;
            color: #A3A7B5;
            line-height: 18px;
        }
    }

    .left-things {
        width: 27.97vw;
        height: auto;
        box-sizing: border-box;
        display: flex;
        justify-content: center;

        .welcome1 {
            width: 537px;
            height: 42px;
            display: block;
            vertical-align: middle;
        }

        .welcome2 {
            width: 465px;
            height: 25px;
            margin-top: 27px;
            display: block;
            vertical-align: middle;
        }
    }

    .logo-part {
        position: absolute;
        left: 23%;
        right: 58.18%;
        bottom: 0;
        top: 14.8%;
        display: flex;
        align-items: center;
        justify-content: center;

        .main-logo {
            position: relative;
            width: 100%;
            height: 42.13vh;
            display: flex;
            justify-content: center;
        }

        .left-part {
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: auto;
            bottom: 0;
            z-index: 10;

            .left1 {
                width: 95px;
                height: 112px;
                animation: leftright 8s infinite linear;
            }

            .left2 {
                width: 60px;
                height: auto;
                animation: transp 8s infinite linear;

                &.blue {
                    width: 91px !important;
                    margin-top: 45px !important;
                }
            }
        }

        .middle-part {
            width: 380px;
            height: 445px;
            position: absolute;
            bottom: 0;

            .middle1 {
                width: 380px;
                height: 445px;
                position: relative;
                z-index: 9;
                animation: updown 5s infinite linear;
            }

            .middle2 {
                width: 398px;
                height: 192px;
                animation: transp 5s infinite linear;
                margin-top: -137px;
            }
        }

        .right-part {
            position: absolute;
            display: flex;
            flex-direction: column;
            align-items: center;
            height: auto;
            bottom: 0;
            z-index: 10;

            .right1 {
                width: 66px;
                height: 74px;
                position: relative;
                z-index: 9;
                animation: leftright 8s infinite linear;
            }

            .right2 {
                height: auto;
                animation: transp 8s infinite linear;
                margin-top: 0;

                &.blue {
                    width: 64px !important;
                    margin-top: 0px !important;
                }
            }
        }
    }
}

@keyframes updown {
    0% {
        transform: translateY(0);

    }

    25% {
        transform: translateY(-12.5px);

    }

    50% {
        transform: translateY(-25px);

    }

    75% {
        transform: translateY(-12.5px);

    }

    100% {
        transform: translateY(0);

    }
}

@keyframes leftright {
    0% {
        transform: translateY(0px);

    }

    25% {
        transform: translateY(-15px);

    }

    50% {
        transform: translateY(-30px);

    }

    75% {
        transform: translateY(-15px);

    }

    100% {
        transform: translateY(0px);

    }
}

@keyframes transp {
    0% {
        opacity: 1;
    }

    25% {
        opacity: 0.6;
    }

    50% {
        opacity: 0.3;
    }

    75% {
        opacity: 0.6;
    }

    100% {
        opacity: 1;

    }
}

.yearLogin {
    background: #B73A20 !important;
}

.yearLogin:hover {
    background: #A63118 !important;
}
</style>
